export default __webpack_public_path__ + "static/media/preview-1.1b479b41.jpg";